import { render } from "./HiddenRecord.vue?vue&type=template&id=160cd467&scoped=true"
import script from "./HiddenRecord.vue?vue&type=script&lang=js"
export * from "./HiddenRecord.vue?vue&type=script&lang=js"

import "./HiddenRecord.vue?vue&type=style&index=0&id=160cd467&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160cd467"]])

export default __exports__